// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__d3xsg","label":"Category_label__23aAE","content":"Category_content__2HVC-","header":"Category_header__2Z81F","location":"Category_location__3uKJA"};